// extracted by mini-css-extract-plugin
export default {"SettingsDotsContainer":"verticalDots_SettingsDotsContainer__V3Ajb","SettingsButton":"verticalDots_SettingsButton__A4lDa"};